/**
 * Static-replica provider for the global live-prices poll.
 *
 * No Twelve Data stream in this v0 replica → always an empty price map.
 */

export interface LivePriceTick {
  price: number;
  change: number;
  changePct: number;
  timestamp: string;
}

export function useEtfLivePrices(): { prices: Record<string, LivePriceTick> } {
  return { prices: {} };
}
